import axios from 'axios'

const OPENED_FROM_FS = window.location.origin.startsWith('file://')
let appId
if (OPENED_FROM_FS) {
    const params = (window.location.search || '').split('&')
    const appIdQ = params.find(elm => elm.startsWith('vk_app_id'))
    if (appIdQ) {
        appId = appIdQ.split('=')[1]
    }
}
const PROD_APP_ID = '5697645'
const DOMAIN_ADDRESS = OPENED_FROM_FS
  ? (appId === PROD_APP_ID ? 'https://xn--j1ab.xn----ptbggfebebr8g.xn--p1ai' : 'https://xn----7sbaae8axci0arc3a.xn----ptbggfebebr8g.xn--p1ai') : ''
const API_PREFIX = `${DOMAIN_ADDRESS}/api`
const ACCESS_PREFIX = '/access'
const ACQUIRING_PREFIX = '/acquiring'
const MESS_PREFIX = `${ACCESS_PREFIX}/messages`
const TOKEN_PREFIX = `${ACCESS_PREFIX}/group/token`
const CUSTOMERS_PREFIX = '/customers'
const BALANCES_PREFIX = `${CUSTOMERS_PREFIX}/balances`
const BUYOUTS_PREFIX = `${CUSTOMERS_PREFIX}/buyouts`
const BUYOUTS_ITEMS_PREFIX = `${BUYOUTS_PREFIX}/items`
const DELIVERY_MESSAGE_PERMISSIONS_PREFIX = '/delivery/message/permissions'
const EVENTS_PREFIX = `${CUSTOMERS_PREFIX}/events`
const PICKUP_POINTS_PREFIX = `${CUSTOMERS_PREFIX}/pickupPoints`
const PROFILES_PREFIX = `${CUSTOMERS_PREFIX}/profiles`
const SOURCE_SETTINGS_PREFIX = '/sources/settings'
const STORE_PREFIX = `${CUSTOMERS_PREFIX}/store`
const USER_PREFIX = '/user'
const WIDGET_PREFIX = '/sources/widget'

window.INITIAL_HASH_FROM_PATH = window.location.hash.replace('#', '')

// function makeLoginUrl(redirectUrl) {
//     return `${this.LOGIN_URL}?redirectUri=${redirectUrl}`
// }

const API = Object.freeze({
    APP_CRM_URL: 'https://органайзер.сп-помощник.рф',
    APP_INSTRUCTION_URL: 'https://сп-помощник.рф/lk_install.html',
    APP_STORE_URL: 'https://магазин.сп-помощник.рф',
    DOMAIN_ADDRESS,
    LOGIN_URL: `${DOMAIN_ADDRESS}/api/auth/start`,
    LOGOUT_URL: `${DOMAIN_ADDRESS}/api/auth/logout`,
    WS: window.location.hostname === 'localhost' ? 'https://заказы.сп-помощник.рф/ws' : '/ws',
    VK_CONTEXT_URL: 'https://vk.com',
    VK_PERSONAL_DIALOG_PREFIX: 'https://vk.me/id',
    SUPPORT_URL: 'https://vk.me/sp_pom',
    ACCESS: {
        MESSAGES: {
            GET: MESS_PREFIX,
            ACCEPT: `${MESS_PREFIX}/accept`,
            REJECT: `${MESS_PREFIX}/reject`
        },
        TOKEN: {
            GET: TOKEN_PREFIX,
            UPDATE: `${TOKEN_PREFIX}/update`,
            REJECT: `${TOKEN_PREFIX}/reject`
        }
    },
    ACQUIRING: {
        INFO: `${ACQUIRING_PREFIX}/info`
    },
    BALANCES: {
        INFO: `${BALANCES_PREFIX}/info`,
        ITEMS: `${BALANCES_PREFIX}/items`
    },
    BUYOUTS: {
        ADMIN_LIST: 'buyouts',
        ITEM: `${BUYOUTS_PREFIX}/item`,
        BUYOUT_ITEM: `${BUYOUTS_ITEMS_PREFIX}`,
        BUYOUT_ITEM_ARCHIVE: `${BUYOUTS_ITEMS_PREFIX}/archive`,
        BUYOUT_ITEM_UNARCHIVE: `${BUYOUTS_ITEMS_PREFIX}/unarchive`,
        BUYOUT_ITEM_PICKUP_POINTS: `${BUYOUTS_ITEMS_PREFIX}/pickupPoints`,
        BUYOUT_ITEM_INVOICE: `${BUYOUTS_ITEMS_PREFIX}/invoices`,
        BUYOUT_ITEM_INVOICE_PAY: `${BUYOUTS_ITEMS_PREFIX}/invoices/pay`,
        LIST: BUYOUTS_PREFIX,
        PAYMENTS_ITEM: `${BUYOUTS_PREFIX}/payments/item`,
        STATUSES: `${BUYOUTS_PREFIX}/statuses`
    },
    COMMENTS: {
        LIST: `${CUSTOMERS_PREFIX}/comments`
    },
    EVENTS: {
        DATE_SET: `${EVENTS_PREFIX}/date/set`,
        LIST: EVENTS_PREFIX,
        NEW_SIZE: `${EVENTS_PREFIX}/new/size`
    },
    DELIVERY: {
        MESSAGE: {
            PERMISSIONS: {
                SETUP: `${DELIVERY_MESSAGE_PERMISSIONS_PREFIX}/setup`
            }
        }
    },
    OPENED_FROM_FS,
    PICKUP_POINTS: {
        DEFAULT: {
            GET: `${PICKUP_POINTS_PREFIX}/default`,
            SET: `${PICKUP_POINTS_PREFIX}/default/set`,
        },
        LIST: `${PICKUP_POINTS_PREFIX}`
    },
    PROFILES: {
        ITEM: `${PROFILES_PREFIX}/item`,
        REVIEWS: {
            ANSWERS: {
                CREATE: `${PROFILES_PREFIX}/reviews/answers/create`,
                DELETE: `${PROFILES_PREFIX}/reviews/answers/delete`
            }
        }
    },
    SOURCES: {
        ITEM: `${CUSTOMERS_PREFIX}/sources/item`,
        LIST: `${CUSTOMERS_PREFIX}/sources`,
        SETTINGS: {
            LIST: `${SOURCE_SETTINGS_PREFIX}`,
            SET:  `${SOURCE_SETTINGS_PREFIX}/set`,
            CONFIRMATION_TYPE: `${SOURCE_SETTINGS_PREFIX}/confirmationType`,
            COMMON: `${SOURCE_SETTINGS_PREFIX}/common`,
        },
        WIDGET: {
            DELETE: `${WIDGET_PREFIX}/delete`,
            INSTALL: `${WIDGET_PREFIX}/install`,
            PREVIEW: `${WIDGET_PREFIX}/preview`
        }
    },
    STORE: {
        INSTALLED: `${STORE_PREFIX}/installed`
    },
    USER: {
        INFO: `${USER_PREFIX}/info`,
        INTRO_SKIP: `${USER_PREFIX}/intro/skip`,
        PROFILE: `${CUSTOMERS_PREFIX}/user/profile`
    }
})

const client = axios.create({
    baseURL: API_PREFIX,
})

if (window.location.search) {
    client.defaults.headers.common['Url'] = window.location.search
}

client.interceptors.response.use(
  response => {
      const data = response.data.data || {}
      data.rqId = response.data.rqId
      return Promise.resolve(data)
  },
  error => {
      if (error.response && error.response.data.error) {
          const newError = error.response.data.error
          newError.code = error.response.data.code
          return Promise.reject(newError)
      } else if (error.response) {
          return Promise.reject({
              message: 'Во время запроса произошла ошибка',
              additionalInfo: error.response.data,
              code: error.response.status
          })
      }
      return Promise.reject(error)
  }
)

export {
    API,
    client
}
